export const supportConstants = {

    GET_TICKET_PRIORITY_REQUEST: 'GET_TICKET_PRIORITY_REQUEST',
    GET_TICKET_PRIORITY_SUCCESS: 'GET_TICKET_PRIORITY_SUCCESS',
    GET_TICKET_PRIORITY_FAILURE: 'GET_TICKET_PRIORITY_FAILURE',

    GET_TICKET_TYPE_REQUEST: 'GET_TICKET_TYPE_REQUEST',
    GET_TICKET_TYPE_SUCCESS: 'GET_TICKET_TYPE_SUCCESS',
    GET_TICKET_TYPE_FAILURE: 'GET_TICKET_TYPE_FAILURE',

    ADD_NEW_TICKET_REQUEST: 'ADD_NEW_TICKET_REQUEST',
    ADD_NEW_TICKET_SUCCESS: 'ADD_NEW_TICKET_SUCCESS',
    ADD_NEW_TICKET_FAILURE: 'ADD_NEW_TICKET_FAILURE',

    GET_TICKETS_LIST_REQUEST: 'GET_TICKETS_LIST_REQUEST',
    GET_TICKETS_LIST_SUCCESS: 'GET_TICKETS_LIST_SUCCESS',
    GET_TICKETS_LIST_FAILURE: 'GET_TICKETS_LIST_FAILURE',

    GET_TICKET_DETAILS_REQUEST: 'GET_TICKET_DETAILS_REQUEST',
    GET_TICKET_DETAILS_SUCCESS: 'GET_TICKET_DETAILS_SUCCESS',
    GET_TICKET_DETAILS_FAILURE: 'GET_TICKET_DETAILS_FAILURE',
   
    ACCEPT_TICKET_REQUEST: 'ACCEPT_TICKET_REQUEST',
    ACCEPT_TICKET_SUCCESS: 'ACCEPT_TICKET_SUCCESS',
    ACCEPT_TICKET_FAILURE: 'ACCEPT_TICKET_FAILURE',
    
    ADD_MESSAGE_TICKET_REQUEST: 'ADD_MESSAGE_TICKET_REQUEST',
    ADD_MESSAGE_TICKET_SUCCESS: 'ADD_MESSAGE_TICKET_SUCCESS',
    ADD_MESSAGE_TICKET_FAILURE: 'ADD_MESSAGE_TICKET_FAILURE',
    
    CLOSE_TICKET_REQUEST: 'CLOSE_TICKET_REQUEST',
    CLOSE_TICKET_SUCCESS: 'CLOSE_TICKET_SUCCESS',
    CLOSE_TICKET_FAILURE: 'CLOSE_TICKET_FAILURE',

    UPDATE_TICKET_DETAILS_BY_ID: 'UPDATE_TICKET_DETAILS_BY_ID',

};
